import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenerateEmissionReportComponent } from 'src/app/shared/components/generate-emission-report/generate-emission-report.component';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getmonths, getShipNameOptions, gettypeofreport, getvesselname } from 'src/app/shared/helpers/dropdown-options';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { EmissionService } from 'src/app/shared/service/emission-service/emission.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { MatSort, Sort } from '@angular/material/sort';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';
import { isEmzoilVessel, normalizeEmissionVesselClient } from 'src/app/shared/helpers/emission-client-filter.util';

@Component({
  selector: 'app-mrv',
  templateUrl: './mrv.component.html',
  styleUrls: ['./mrv.component.scss']
})
export class MRVComponent implements OnInit, OnDestroy {


  @ViewChild(MatSort) sort!: MatSort;

  myreportForm: FormGroup;
  monthOptions: any;
  shipnameoptions: any;
  vesselnameoptions: any;
  typeofreportoptions: string[];

  paginatedData: any[] = [];
  currentPage: number = 0;
  itemsPerPage: number = 100;

  elements: any[] = [];
  vesselNameSuggestions: any[] = [];

  isLoading: boolean = false;
  selectedReport: string = '';
  username: string = '';
  clientList: string[] = [];
  clientFilters: { [key: string]: (item: any) => boolean } = {
    'Eiger Shipping': (item) => item.client_name === 'Eiger' && !isEmzoilVessel(item),
    'Zeronorth ZN': (item) => item.client_name === 'ZeroNorth',
    'Elite Shipping': (item) =>
      item.client_name === 'Elite' ||
      item.client_name === 'ELITE TANKSHIP DMCC',
    'Bunge Shipping': (item) => item.client_name === 'Bunge',
    'Alcor Shipping': (item) =>
      item.client_name === 'ALCOR CHARTERING DMCC',
    'EMZoil Shipping': (item) =>
      item.client_name === 'EMZ OIL' ||
      item.client_name === 'EMZOIL FZCO' ||
      item.client_name?.toLowerCase().includes('emz') ||
      isEmzoilVessel(item),
    'Ethiopian Shipping & Logistics': (item) =>
      item.client_name?.toLowerCase() === 'ethiopian shipping & logistics',
  };

  reportOptions = [
    { label: 'Average Temp Forecast', value: 'avg_temp_forecast' },
    { label: 'Tank Temp Forecast', value: 'tank_temp_forecast' },
    { label: 'Heat Plan', value: 'heat_plan' },
    { label: 'Bunker Report', value: 'bunker_forecast' }
  ];
  private destroy$ = new Subject<void>();
  subusername: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private emissionService: EmissionService,
    private commonService: CargoheatingCommonService,
    private router: Router,
    private overlayService: OverlapService,
    private requestFormService: RequestFormService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.myreportForm = this.fb.group({
      vesselname: [''],
      typeofreport: [''],
      from_date: [''],
      to_date: [''],
      month: [''],
      vesselIMO: ['', [Validators.pattern('^[0-9]*$')]],
      client: [''],
    });

    this.username = localStorage.getItem('username') ?? '';

    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.vesselnameoptions = getvesselname();
    this.typeofreportoptions = gettypeofreport();
  }

  ngOnInit(): void {
     this.subusername = localStorage.getItem('loginPic') ?? '';
    this.fetchReportTableData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe((sort: Sort) => {
        this.sortData(sort);
      });
    }
  }

  applyClientFilter(sourceData: any[]) {
    const selectedClient = this.myreportForm.get('client')?.value;

    if (this.username === 'Meraki - Operations') {
      if (selectedClient && this.clientFilters[selectedClient]) {
        this.elements = sourceData.filter(this.clientFilters[selectedClient]);
      } else {
        this.elements = sourceData;
      }
    } else if (this.clientFilters[this.username]) {
      this.elements = sourceData.filter(this.clientFilters[this.username]);
    } else {
      this.elements = sourceData;
    }

    if (this.subusername?.toLowerCase() === 'grace') {
      const graceImos = ['9378876', '9399480', '9438406', '9432048'];
      this.elements = this.elements.filter((item: any) =>
        graceImos.includes(String(item.imo_number ?? item.ship_imo ?? item.imo ?? '').trim())
      );
    }
  }

  fetchReportTableData(isInitialFetch = true, params: any = {}): void {
    this.isLoading = true;

    this.emissionService.getETSVessels(params).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
         let vessels = res?.vessels || [];
         vessels.forEach(normalizeEmissionVesselClient);
        if (this.subusername?.toLowerCase() === 'grace') {
          const graceImos = ['9378876', '9399480', '9438406', '9432048'];
          vessels = vessels.filter((v: any) =>
            graceImos.includes(String(v.imo_number ?? v.ship_imo ?? v.imo ?? '').trim())
          );
        }
        if (isInitialFetch) {
  
          vessels = this.filterAndMaskDemoVoyages(vessels);
          this.vesselNameSuggestions = vessels;
          this.clientList = Object.keys(this.clientFilters).filter((clientKey) => {
            return vessels.some((v: any) => this.clientFilters[clientKey](v));
          });
        }

        const searchResults = vessels || [];
        this.applyClientFilter(searchResults);

        this.currentPage = 0;
        this.paginateData();

        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        console.error(error);
        this.toastr.error('Failed to load UK MRV table data');
      },
    );
  }

  showDetails(row: any) {
    const imo = row?.original_vessel_imo || row?.imo || row?.imo_number || row?.ship_imo || row?.vessel_imo;
    if (imo) {
      this.router.navigate(['/E-Uk-ShipView', imo]);
    } else {
      console.error('IMO number is missing from row data', row);
      this.toastr.warning('Vessel IMO is not available');
    }
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    const isAsc = sort.direction === 'asc';

    this.paginatedData = data.sort((a, b) => {
      const valueA = a[sort.active];
      const valueB = b[sort.active];
      if (valueA == null) return isAsc ? -1 : 1;
      if (valueB == null) return isAsc ? 1 : -1;
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    });
  }

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements.slice(startIndex, startIndex + this.itemsPerPage);
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  openGenerateReportPopup(row: any) {
    this.dialog.open(GenerateEmissionReportComponent, {
      width: '560px',
      data: { ...row, reportType: 'UKMRV' },
      disableClose: true,
    });
  }

  filterClick() {
    const params: any = {};
    const vesselName = this.myreportForm.get('vesselname')?.value;
    const vesselIMO = this.myreportForm.get('vesselIMO')?.value;

    if (vesselName && vesselName.length > 0) {
      params.vessel_names = Array.isArray(vesselName) ? vesselName.join(',') : vesselName;
    }
    if (vesselIMO) {
      params.vessel_imo = vesselIMO;
    }

    this.fetchReportTableData(false, params);
  }

  clearClick() {
    this.myreportForm.reset();
    this.fetchReportTableData();
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  refreshPageData() {
    this.isLoading = true;
    this.fetchReportTableData();
  }
  private isDemoUser(): boolean {
    const username = (localStorage.getItem('username') || '').toLowerCase();
    const loginPic = (localStorage.getItem('loginPic') || '').toLowerCase();
    const subuser = (this.subusername || '').toLowerCase();
    return subuser === 'demo' || loginPic === 'demo' || username === 'meraki - demo' || username.includes('demo');
  }
    
    private filterAndMaskDemoVoyages(voyages: any[]): any[] {
      if (!this.isDemoUser()) {
        return voyages;
      }
    
      return (voyages || [])
        .filter((v: any) => {
          const imo = String(
            v?.imo_number ??
            v?.ship_imo ??
            v?.imo ??
            ''
          ).trim();
    
          return DEMO_VESSEL_PC.includes(imo);
        })
        .map((v: any) => {
          const imo = String(
            v?.imo_number ??
            v?.ship_imo ??
            v?.imo ??
            ''
          ).trim();
    
          const index = DEMO_VESSEL_PC.indexOf(imo);
    
          return {
            ...v,
             original_vessel_imo: v.imo,
             original_vessel_name: v.vessel_name,
            // Mask vessel name
            vessel_name: `Vessel ${index + 1}`,
            ship_name: `Vessel ${index + 1}`,
            client_name: 'Client 1',
            // Mask IMO
            imo: 'xxxxxxx',
            ship_imo: 'xxxxxxx',
          };
        });
    }
}
